// Singleton mirroring organizationManager: holds the selected region ids so the
// header helper can read them without React hooks. Empty = no region filter (All).
class RegionManager {
  private currentRegionIds: string[] = [];
  private listeners: Set<(regionIds: string[]) => void> = new Set();

  setRegionIds(ids: string[]) {
    const next = [...ids].sort();
    if (
      next.length !== this.currentRegionIds.length ||
      next.some((id, i) => id !== this.currentRegionIds[i])
    ) {
      this.currentRegionIds = next;
      this.notifyListeners(next);
    }
  }

  getRegionIds(): string[] {
    return this.currentRegionIds;
  }

  addListener(callback: (regionIds: string[]) => void) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  private notifyListeners(regionIds: string[]) {
    this.listeners.forEach((callback) => callback(regionIds));
  }

  clear() {
    this.setRegionIds([]);
  }
}

export const regionManager = new RegionManager();
export default regionManager;
